module.exports = __webpack_public_path__ + "components/homepage-hero/static/hero-bg-580@2x-0ab1795a54a6a57366eac9a6bb7a05a8.jpg";